import {
  SimuInfoGraph,
  GenerateSimulationHistory,
  SimulationGetSendValueRequest,
  CreateSimulationHistoryBlock
} from '../Utils/simulation_utils.js';

import { Ran } from '../Utils/utils.js';
import { resolutions } from '../Constants/constants';

export default function simulationOnMessage(simulation, resp) {
  if (!simulation) return;
  const username = simulation.username;
  console.log('[simulation-ws] Simulation got command: ', resp);
  //Try to parse command.
  let command = '';
  try {
    command = resp['command'];
  } catch (err) {
    return;
  }
  console.log('[simulation-ws] Simulation got command: ', command);

  //Setup initial response
  var json_response = { username: username, command: '' };

  // request_values -> send values to server
  if (command === 'request_values') {
    // If a new zone was recently added, send full-values again
    if (simulation.has_new_zone) {
      json_response = SimulationGetSendValueRequest(
        true,
        simulation.controller.id,
        simulation.zones
      );
      simulation.has_new_zone = false;
    } else {
      json_response = SimulationGetSendValueRequest(
        false,
        simulation.controller.id,
        simulation.zones
      );
    }
  } else if (command === 'request_values_full') {
    json_response = SimulationGetSendValueRequest(true, simulation.controller.id, simulation.zones);
  }
  // action -> randomly reply with true or false
  else if (command === 'action') {
    const data = resp['data'];
    // Only answer if action is not the delete-controller-action.
    if (data['id'] !== 'reset_controller_credentials') {
      json_response['command'] = 'resp_action';
      json_response['data'] = { success: true };
      json_response['data']['info'] = { id: data['id'] };
      if ('value' in data) json_response['data']['info']['value'] = data['value'];
    }
  }
  // update_setpoints -> send error or success message.
  else if (command === 'update_setpoints') {
    // Construct response message.
    const category = resp['data'] !== null ? Object.keys(resp['data'])[0] : '';
    json_response['command'] = 'message';
    json_response['data'] = {};
    if (resp['data'] !== null && Ran(0, 1) === 1) {
      json_response['data']['type'] = 'success';
      json_response['data']['message_parts'] = [
        category,
        ': ',
        'all',
        ' ',
        'gc_ms_settings_accepted'
      ];
    } else {
      json_response['data']['type'] = 'error';
      json_response['data']['message_parts'] = [
        category,
        ': ',
        'gc_ms_nothing_changed',
        ' - 1 ',
        'gc_ms_setting_rejected',
        ': 5'
      ];
    }
    json_response['data']['timestamp'] = Date.now();
  } else if (command === 'clear_msg_log') {
    json_response['command'] = 'send_all_messages';
    json_response['internal_id'] = simulation.id;
    json_response['data'] = { all_messages: [] };
  } else if (command === 'get_all_messages') {
    // json_response["command"] = "send_all_messages";
    // var date = new Date();
    // json_response["data"] = {
    //   "all_messages":[
    //     {
    //       "message_parts":["test_message", " ", "test_message_2"],
    //       "type":"info",
    //       "timestamp":date.getTime(),
    //     }
    //   ]
    // };
  } else if (command === 'get_recent_history') {
    const date = new Date();
    json_response['command'] = 'send_recent_history';
    json_response['internal_id'] = simulation.controller.id;
    json_response['is_zoned'] = simulation.zones.length > 0;
    // Send 1. block
    var history_block = GenerateSimulationHistory(60, resolutions.recent, 0, 2);
    history_block['progress'] = 0;
    history_block['part'] = 0;
    history_block['timestamp'] = date.getTime();
    json_response['data'] = CreateSimulationHistoryBlock(
      history_block,
      simulation.zones,
      resp.data
    );
    simulation.socket.send(JSON.stringify(json_response));
    // Send 2. block
    history_block = GenerateSimulationHistory(60, resolutions.recent, 1, 2);
    history_block['progress'] = 100;
    history_block['part'] = 1;
    history_block['timestamp'] = date.getTime();
    json_response['data'] = CreateSimulationHistoryBlock(
      history_block,
      simulation.zones,
      resp.data
    );
  } else if (command === 'get_daily_history') {
    console.log('[hist] handling `get_daily_history`');
    const date = new Date();
    json_response['command'] = 'send_daily_history';
    json_response['internal_id'] = simulation.controller.id;
    json_response['is_zoned'] = simulation.zones.length > 0;
    // Send 1. block
    var history_block = GenerateSimulationHistory(720, resolutions.daily, 0, 2);
    history_block['progress'] = 0;
    history_block['part'] = 0;
    history_block['timestamp'] = date.getTime();
    json_response['data'] = CreateSimulationHistoryBlock(
      history_block,
      simulation.zones,
      resp.data
    );
    simulation.socket.send(JSON.stringify(json_response));
    // Send 2. block
    history_block = GenerateSimulationHistory(720, resolutions.daily, 1, 2);
    history_block['progress'] = 100;
    history_block['part'] = 1;
    history_block['timestamp'] = date.getTime();
    json_response['data'] = CreateSimulationHistoryBlock(
      history_block,
      simulation.zones,
      resp.data
    );
    console.log('[hist] handling `get_daily_history` done.');
  } else if (command === 'get_history') {
    const date = new Date();
    json_response['command'] = 'send_history';
    json_response['internal_id'] = simulation.controller.id;
    json_response['is_zoned'] = simulation.zones.length > 0;
    // Send 1. block
    var history_block = GenerateSimulationHistory(1175, resolutions.full, 0, 6);
    history_block['progress'] = 0;
    history_block['part'] = 0;
    history_block['timestamp'] = date.getTime();
    json_response['data'] = CreateSimulationHistoryBlock(
      history_block,
      simulation.zones,
      resp.data
    );
    simulation.socket.send(JSON.stringify(json_response));
    // Send 2. block
    history_block = GenerateSimulationHistory(1175, resolutions.full, 1, 6);
    history_block['progress'] = 20;
    history_block['timestamp'] = date.getTime();
    history_block['part'] = 1;
    json_response['data'] = CreateSimulationHistoryBlock(
      history_block,
      simulation.zones,
      resp.data
    );
    simulation.socket.send(JSON.stringify(json_response));
    // Send 3. block
    history_block = GenerateSimulationHistory(1175, resolutions.full, 2, 6);
    history_block['progress'] = 40;
    history_block['part'] = 2;
    history_block['timestamp'] = date.getTime();
    json_response['data'] = CreateSimulationHistoryBlock(
      history_block,
      simulation.zones,
      resp.data
    );
    simulation.socket.send(JSON.stringify(json_response));
    // Send 4. block
    history_block = GenerateSimulationHistory(1175, resolutions.full, 3, 6);
    history_block['progress'] = 60;
    history_block['part'] = 3;
    history_block['timestamp'] = date.getTime();
    json_response['data'] = CreateSimulationHistoryBlock(
      history_block,
      simulation.zones,
      resp.data
    );
    simulation.socket.send(JSON.stringify(json_response));
    // Send 5. block
    history_block = GenerateSimulationHistory(1175, resolutions.full, 4, 6);
    history_block['progress'] = 80;
    history_block['timestamp'] = date.getTime();
    history_block['part'] = 4;
    json_response['data'] = CreateSimulationHistoryBlock(
      history_block,
      simulation.zones,
      resp.data
    );
    simulation.socket.send(JSON.stringify(json_response));
    // Send 6. block
    history_block = GenerateSimulationHistory(1175, resolutions.full, 5, 6);
    history_block['progress'] = 100;
    history_block['part'] = 5;
    history_block['timestamp'] = date.getTime();
    json_response['data'] = CreateSimulationHistoryBlock(
      history_block,
      simulation.zones,
      resp.data
    );
  } else if (command === 'resolve_alarm') {
    json_response['command'] = 'alarms_resolved';
    const timestamp = new Date().getTime();
    json_response['data'] = {};
    json_response['data']['alarm_keys'] = [resp['data']['alarm_id']];
    json_response['data']['timestamp'] = timestamp;
  } else if (command === 'get_info_graphs') {
    json_response['command'] = 'send_info_graphs';
    json_response['internal_id'] = simulation.controller.id;
    json_response['data'] = { humidity_graph: [], temp_graph: [] };
    json_response['data']['humidity_graph'] = SimuInfoGraph(600, 760);
    json_response['data']['temp_graph'] = SimuInfoGraph(220, 240);
  } else if (command === 'get_fs_status') {
    console.log('[sumilation-ws] handling cmd `get_fs_status`');
    json_response['command'] = 'fs_status';
    json_response['data'] = {};
    json_response['data']['total_size'] = 33138688;
    json_response['data']['free'] = 42;
    json_response['data']['flash_status'] = 1;
    json_response['data']['fs_status'] = 1;
  } else if (command === 'rename_zone') {
    const data = resp['data'];
    for (var i = 0; i < simulation.zones.length; i++) {
      if (simulation.zones[i].id === data['id']) simulation.zones[i].name = data['name'];
    }
  } else if (command === 'add_zone') {
    const data = resp['data'];
    console.log('[RH] add zone: ', data['name'], ' cur: ', JSON.stringify(simulation.zones));
    simulation.zones.push({ id: simulation.zones.length.toString(), name: data['name'] });
    simulation.has_new_zone = true;
    console.log('[RH] add zone. Now: ', JSON.stringify(simulation.zones));
  } else if (command === 'delete_zone') {
    const data = resp['data'];
    console.log('[RH] delete zone: ', data['id'], ' cur: ', JSON.stringify(simulation.zones));
    simulation.zones = simulation.zones.filter((zone) => {
      return zone.id !== data['id'];
    });
  }

  // Send response, when command was set:
  if (json_response['command'] !== '') {
    if (simulation.socket !== undefined && simulation.socket.readyState === 1) {
      json_response['internal_id'] = simulation.controller.id;
      json_response.socket = simulation.socket;

      console.log('[simulation-ws] sending: ', json_response['command']);
      simulation.sendWSMsg(json_response);
    }
  }
}
